var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_12045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0359 0.678574H0.678711V18.3214H21.0359V0.678574Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.678711 4.75H21.0359",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78557 7.46428H4.07129V10.1786H6.78557V7.46428Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2143 7.46428H9.5V10.1786H12.2143V7.46428Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.643 7.46428H14.9287V10.1786H17.643V7.46428Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78557 12.8929H4.07129V15.6071H6.78557V12.8929Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2143 12.8929H9.5V15.6071H12.2143V12.8929Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.643 12.8929H14.9287V15.6071H17.643V12.8929Z",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_12045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.7143,
    height: 19,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.58400ccc.svg";
export { ForwardRef as ReactComponent };